import { Link, useNavigate, useParams } from 'react-router-dom'

import { API_ADR, ProjectStatus, LoadingBar, AM_UserDateTime, dBConn } from '../../ApiCenter/API_GET';
import { ColumnsDirective, ColumnDirective, Inject, ColumnChooser } from '@syncfusion/ej2-react-treegrid';
import { TreeGridComponent, Resize, Filter, InfiniteScroll, VirtualScroll, Page } from '@syncfusion/ej2-react-treegrid';
import { useEffect, useState, useRef, forwardRef, useImperativeHandle, useContext, Fragment } from 'react';
import axios from 'axios';
import dayjs from 'dayjs'

import { ProjectsShareForm } from './01_Projects_ShareForm'
import { ProjectsAudioAssociation } from './01_Projects_AudioAssociation'
import { ProjectsAudioTargetSetting1 } from './01_Projects_AudioTargetSetting1'
import { ManageTargetAssets } from '../FileTransfer/ManageTargetAssets'
import { ProjectInfoEdit } from './01_Projects_InfoEdit'
import { InfoContext } from "../../ApiCenter/AM_BackGroundOP"
import Protected from '../../Protected';
import { ColorPickerComponent } from "@syncfusion/ej2-react-inputs";
import SettingsInputCompositeIcon from '@mui/icons-material/SettingsInputComposite';

import $ from 'jquery';
import { size } from 'lodash';
import { toast } from 'react-toastify';


function ProjectHeaderProjects(props) {

    return <div className="pagetitle">
        <h1>Projects</h1>
        <nav>
            <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                <li className="breadcrumb-item active">{props.name}</li>
            </ol>
        </nav>
    </div>
}

//var currentData = []
let gridObj;

let expendedStatus = []
export const ProjectsShow = () => {

    const ctx = useContext(InfoContext);
    const newButtonBar = useRef(null);
    const title = useRef(useParams());
    const [refresh, setRefresh] = useState(false);


    //const [disableButtons, setDisableButtons] = useState(true);
    //const [Selection, setSelection] = useState([]);
    const [valuesTableGrid, setValuesTableGrid] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [operation, setOperation] = useState('Insert')
    //const [userPermission, setUserPermission] = useState(takePermissionLocalStorage)
    const flagCodes = useRef({});


    const includesResults = [0, -1]
    const projectsClosed = localStorage.getItem('projectsClosed')
    if (projectsClosed) {
        includesResults.push(1)
    }

    const levelPBSRef = useRef(includesResults)

    const targetPanel1Ref = useRef();
    const targetPanel2Ref = useRef();
    const sourcePanelRef = useRef();
    const sharePanelRef = useRef();
    const projectInfoEditRef = useRef();

    const currentFilterValue = useRef('');
    const dummyRefs = useRef({})

    // Local override of project colors after a save, so the swatch reflects the change
    // without forcing a full grid reload.
    const [projectColors, setProjectColors] = useState({});
    const [canEditProjectColor, setCanEditProjectColor] = useState(false);
    const [colorEditor, setColorEditor] = useState(null);
    const saveProjectColor = async (projectId, color) => {
        const prevColor = projectColors[projectId];
        setProjectColors(prev => ({ ...prev, [projectId]: color })); // optimistic
        try {
            const res = await axios.post(
                API_ADR('setProjectColor'),
                { project_id: projectId, project_color: color }
            );
            if (!res.data?.success) throw new Error(res.data?.message);
        } catch (e) {
            setProjectColors(prev => ({ ...prev, [projectId]: prevColor })); // revert on failure
            toast.error('Project color not saved');
        }
    };

    useEffect(() => {

        if (title.current?.title !== undefined) {
            localStorage.setItem('projectsSearch', title.current.title)
        }

        const addLanguageTextForFiltering = (items) => {
            if (!items || !Array.isArray(items)) {
                //console.log('Items is not an array:', items);
                return items;
            }
            return items.map(item => {
                if (!item) {
                    //console.log('Item is null/undefined');
                    return item;
                }
                try {
                    return {
                        ...item,
                        language_text: item.language_code || '', // Handle null/undefined values
                        subtasks: item.subtasks && Array.isArray(item.subtasks)
                            ? addLanguageTextForFiltering(item.subtasks)
                            : item.subtasks
                    };
                } catch (error) {
                    //console.error('Error processing item:', item, error);
                    return item;
                }
            });
        };

        const fetchUrl = async () => {
            const filtersApplied = localStorage.getItem('projectsSearch')
            currentFilterValue.current = filtersApplied && filtersApplied !== 'null' ? filtersApplied : '';
            const result = await axios.get(API_ADR(`projectList=${levelPBSRef.current.join(',')}`));
            flagCodes.current = JSON.parse(JSON.parse(result.data.flagsCodes).flagCodes);
            setCanEditProjectColor(!!result.data.can_edit_color);
            const processedData = tempFunction(result.data.dataTable2, result.data.permissions, result.data.userId, null, dummyRefs);
            setValuesTableGrid(addLanguageTextForFiltering(processedData));
            setIsLoading(false)
        };
        fetchUrl();
    }, []);

    useEffect(() => {
        const permisses = ['TargetUploadFiles', 'TargetDownloadFiles', 'SourceUploadFiles', 'SourceDownloadFiles'];
        const showHide = () => {
            const columns = {
                uploadDownload: permisses.some(p => ctx.userData.current?.permissions?.[p]),
                targetSettings: ctx.userData.current?.permissions?.TargetUploadFiles ?? false,
                sourceAudio: ctx.userData.current?.permissions?.SourceUploadFiles ?? false
            };
            Object.entries(columns).forEach(([k, v]) => {
                if (v) {
                    gridObj?.showColumns(k, 'field');
                } else {
                    gridObj?.hideColumns(k, 'field');
                }
            })
        }
        permisses.forEach(p => {
            if (!ctx.compRefs.current?.hasOwnProperty(p)) ctx.compRefs.current[p] = new Set();
            ctx.compRefs.current[p].add(showHide);
        })

        return () => {
            permisses.forEach(p => { ctx.compRefs.current?.[p]?.delete(showHide) })
        }
    }, [ctx])

    const current = $(window).height();
    const projectlistHeight = current - 250;
    document.documentElement.style.setProperty(`--div-height-projectlist`, projectlistHeight + 'px');

    const navigate = useNavigate();

    const openDummy = (e) => {
        const id = e.level === 1 ? e.downloadReference.batch_id : `${e.uploadReference.batch_id}-${e.uploadReference.script_id}`;
        navigate(`/projectsdetails/${id}/dummyscript`);
    }

    useEffect(() => {

    }, [])

    if (isLoading) {
        return <main id="main" className="main"><LoadingBar /></main>
    }

    // custom status column
    function templateStatus(props) {
        return <ProjectStatus pstatus={props} />
    }

    
    function iconsProjectName(props) {

        let letter = ''
        let classIcon = ''
        let color = ''
        if (props.lineContent === 'project') {
            letter = 'P'
            classIcon = 'primary'
        }
        if (props.lineContent === 'batch') {
            letter = 'B'
            classIcon = 'success'
        }
        if (props.lineContent === 'script') {
            letter = props?.level === 2 && props?.isDummy ? 'D' : 'S';
            classIcon = props?.level === 2 && props?.isDummy ? 'warning' : 'danger';
            color = props?.level === 2 && props?.isDummy ? '#000' : '';
        }

        let opacityNum = 1;
        if (props.hasOwnProperty('subtasks') && Array.isArray(props.subtasks)) {
            if (props.subtasks.length === 0) {
                opacityNum = 0.5
            }
        }

        const batchId = props?.downloadReference?.batch_id;
        const deActDummy = props?.level === 1 ? (dummyRefs.current?.[batchId] ?? null) : null;
        const lineThrough = (props?.dummyInactive ?? false) ? 'line-through' : undefined;

        return (
            <>
                <span style={{ "marginRight": "5px", color: color }} className={`iconprbchscrp badge bg-${classIcon}`}>{letter}</span>
                {(props.sharedActive === 1 || props.lineContent === 'project') &&
                    <div style={{ position: 'relative', float: 'right', fontSize: '13px', paddingTop: '4px', zIndex: '10', display: 'flex', gap: '4px', alignItems: 'center'}}>
                        {props.lineContent === 'project' && (() => {
                            // Resolve current color: optimistic local override first, then the row value
                            const currentColor = ((projectColors[props.idElement] ?? props.project_color) || '#888888');
                            const safeColor = currentColor.length === 7 ? currentColor : '#888888';
                            const canEditColor = canEditProjectColor;
                            return (
                                <span
                                    title="Project color"
                                    onClick={(e) => {
                                        if (!canEditColor) return;            // read-only for non-permitted users
                                        e.stopPropagation();
                                        const rect = e.currentTarget.getBoundingClientRect();
                                        setColorEditor({
                                            projectId: props.idElement,
                                            color: safeColor,
                                            top: rect.bottom + 4,             // fixed positioning, viewport coords
                                            left: rect.left
                                        });
                                    }}
                                    style={{
                                        display: 'inline-block', width: '14px', height: '14px',
                                        background: safeColor, border: '1px solid #fff',
                                        boxShadow: '0 0 0 1px rgba(0,0,0,0.35)', borderRadius: '2px',
                                        cursor: canEditColor ? 'pointer' : 'default'
                                    }}
                                />
                            );
                        })()}
                        {props.sharedActive === 1 && <>
                        <Protected returnNull={true} permissions={['createDummyScript']} extraCondition={deActDummy !== null}>
                            <i className={`bi bi-eye${deActDummy?.active ? '' : '-slash'}`} 
                                style={{ cursor: 'pointer'}} 
                                title={`${deActDummy?.active ? 'Hide' : 'Show'} deactivated dummy scripts`}
                                onClick={(e) => showHideDummy(e, props?.downloadReference?.batch_id)}
                            />
                        </Protected>
                        <Protected returnNull={true} permissions={['createDummyScript']} extraCondition={props?.level === 1 || (props?.isDummy ?? false)}>
                            <i className="bi bi-tools" 
                                style={{ cursor: 'pointer'}} 
                                title={`${props.level === 1 ? 'Create a new ' : 'Open '}dummy script`}
                                onClick={() => openDummy(props)}
                            />
                        </Protected>
                        <Protected returnNull={true} permissions={['editInfoPrBtSpt']} >
                            <i className="bi bi-pencil"
                                style={{cursor: 'pointer'}} 
                                title={`Edit ${props.lineContent} properties`}
                                onClick={() => infoEditLine(props)}
                            />
                        </Protected>
                        </>}
                    </div>
                }
                <span style={{opacity: `${opacityNum}`, textDecoration: lineThrough}} title={props.project_name}>{props.project_name}</span>
            </>
        )

    }

    function clientTemplate(props) {
        return (
            <div style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                <span title={props.client_name}>{props.client_name}</span>
            </div>
        )
    }

    function pmsAplsQacsTemplate(props) {

        if (['project', 'script'].includes(props.lineContent)) {
            return null
        }

        const visible = [<div key={props}><i className="bi bi-person-gear"></i> <span>{props.pm_name}</span></div>];
        const title = [`PM: ${props.pm_name}`];
        if (props.apl_id !== "0") {
            visible.push(<div key={`${props}-apl`}><i className="bi-shield-check"></i> <span>{props.apl_name}</span></div>);
            title.push(`APL: ${props.apl_name}`);
        }
        if (props.qac_id !== "0") {
            visible.push(<div key={`${props}-QAC`}><i className="bi-patch-check"></i> <span>{props.qac_name}</span></div>);
            title.push(`QAC: ${props.qac_name}`);
        }

        return (

            <div title={title.join(', ')} style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                {visible.map(el => {
                    return el
                })}
            </div>


        )
    }

    function startDateTemplate(props) {
        if (props.startDate !== undefined) {
            let currentDate = AM_UserDateTime(props.startDate).split(" ")[0]
            return <span>{currentDate}</span>
        }
    }

    function endDateTemplate(props) {
        if (props.endDate !== undefined) {
            let currentDate = AM_UserDateTime(props.endDate).split(" ")[0]
            return <span>{currentDate}</span>
        }
    }


    function headerCellInfo(args) {
        args.node.getElementsByClassName("e-checkbox-wrapper")[0] && args.node.getElementsByClassName("e-checkbox-wrapper")[0].remove();
    }

    let checkHowManyProjectsBatches = [];
    let checkHowManyProjects = [];

    function checkboxChange(args) {

        var dataSource = gridObj.selectionModule.selectedItems;

        newButtonBar.current.statusBar({
            disabled: true,
            ids: {}
        })
        checkHowManyProjectsBatches = 0;
        checkHowManyProjects = 0;
        let SelectionCheck = []

        dataSource.forEach(function (el, idx) {
            if (el.lineContent === 'script' && (!el.isDummy || !el.dummyInactive)) {
                SelectionCheck.push(el.taskID)
            }
            if (el.lineContent === 'batch') {
                checkHowManyProjectsBatches++
            }
            if (el.lineContent === 'project') {
                checkHowManyProjects++
            }
        })

        if (SelectionCheck.length > 0) {
            newButtonBar.current.statusBar({
                disabled: false,
                ids: SelectionCheck
            })
        }

    }


    function linkTo_new(props) {
        if (props.target === 'actors') {
            const dataSource = gridObj.selectionModule.selectedItems;
            let scriptId = null;

            // Récupérer un script ID depuis la sélection (peu importe lequel)
            dataSource.forEach(function (el) {
                if (el.lineContent === 'script') {
                    scriptId = el.taskID; // Utilisez directement l'ID du script
                } else if (el.lineContent === 'batch') {
                    // Prendre le premier script du batch
                    if (el.subtasks && el.subtasks.length > 0) {
                        scriptId = el.subtasks[0].taskID;
                    }
                } else if (el.lineContent === 'project') {
                    // Prendre le premier script du projet
                    if (el.subtasks && el.subtasks.length > 0 &&
                        el.subtasks[0].subtasks && el.subtasks[0].subtasks.length > 0) {
                        scriptId = el.subtasks[0].subtasks[0].taskID;
                    }
                }
            });

            if (!scriptId) return;

            if (props.event.ctrlKey) {
                window.open(`/projectsdetails/${scriptId}/actors`, '_blank');
                return;
            }
            navigate(`/projectsdetails/${scriptId}/actors`);
            return;
        }
        if (props.target === 'actorscript') {
            if (props.event.ctrlKey) {
                window.open('/actorscript', '_blank');
                return
            }
            navigate('/actorscript');
        } else {

            if (props.event.ctrlKey) {
                window.open(`/projectsdetails/${props.ids}/${props.target}`, '_blank');
                return
            }
            navigate(`/projectsdetails/${props.ids}/${props.target}`);
        }
    }
    /* SHARE RESOURCES */

    function close(message) {

        if (message === 'reload') {

            const fetchUrl = async () => {

                const result = await axios.get(API_ADR(`projectList=${levelPBSRef.current.join(',')}`));

                let reloadData = tempFunction(result.data.dataTable2, result.data.permissions, result.data.userId, null, dummyRefs)
                //setValuesTableGrid(previous => reloadData)

                gridObj.setProperties({ dataSource: reloadData })

                newButtonBar.current.statusBar({
                    disabled: true,
                    ids: {}
                })
            };
            fetchUrl();
            //setReload(reload + 1)
        }
    }


    function sharingSystem(props) {

        if (props.sharedActive === -1) { return }

        const listLitle = props?.joinGroups?.length > 0 ? "Users and Teams:\n" + props.joinGroups.split(',').join('\n') : '';

        let addStyle = { marginRight: '5px', fontSize: '12px', padding: '0px', color: '#c1c1c1' }// gray
        if (listLitle.length > 0) {
            addStyle = { ...addStyle, color: '#4154F1' } // blue
        }

        return (
            <>
                {props.sharedActive > -1 &&
                    <Protected returnNull={true} permissions={['assignResources']} >
                        <button className="btn btn-sm shadow-none"
                            onClick={() => shareResources(props)}
                            style={addStyle}
                            title={`Share Resources for the ${props.lineContent}`}>
                            <i className="bi bi-share"></i>
                        </button>
                    </Protected>
                }
                <span title={listLitle}>{props.joinGroups}</span>
            </>
        )
    }

    /* flags template */

    function flagsTemplate(props) {

        if (props.language_code !== undefined) {

            if (props.lineContent === 'project') {

                let output = []

                props.language_code.forEach(function (el, idx) {
                    // split after 2 letters and insert the synmbol -
                    //let splitLanguageCode = el.match(/.{1,2}/g).join('-')

                    let flagCode = flagCodes.current[el]?.flag;
                    let language = flagCodes.current[el]?.language + ' (' + el + ')';
                    if (flagCode && language) {
                        output.push(<div key={idx} className={`flag-icon flag-icon-${flagCode}`} title={language} style={{ minWidth: '26px', margin: '2px 2px' }}></div>)
                    }

                })
                return <div style={{ display: 'flex', flexWrap: 'wrap' }}>{output}</div>
            }

            if (props.lineContent === 'script') {
                // split after 2 letters and insert the synmbol - 
                //let splitLanguageCode = props.language_code.match(/.{1,2}/g).join('-')
                let flagCode = flagCodes.current[props.language_code]?.flag;
                let language = flagCodes.current[props.language_code]?.language + ' (' + props.language_code + ')';

                return flagCode && language && <div
                    className={`flag-icon flag-icon-${flagCode}`}
                    title={language}
                    style={{ width: '26px' }}
                ></div>
            }
        }
    }

    /* function share resources */
    function shareResources(props) {

        const object = {
            infoLevel: props.lineContent,
            idElement: props.idElement,
            nameElement: props.project_name,
            isLocal: props.sharedActive
        }

        sharePanelRef.current.openShareModal(object)

        //setOperation(object)

    }

    /* function audio association */

    function iconAudioAssociation(props) {

        if (props.lineContent !== 'project' && props.sharedActive === 1) {

            let addStyle = { marginRight: '5px', fontSize: '17px', padding: '0px', color: '#c1c1c1', position: 'relative', top: '2px' }
            if (props.audiobase_set === '1') {
                addStyle = { marginRight: '5px', fontSize: '17px', padding: '0px', color: '#21af00', position: 'relative', top: '2px' }
            }
            if (props.lineContent === 'script') {
                addStyle.fontSize = '12px'
            }



            return (
                props.lineContent === 'batch' ?
                    <button className="btn btn-sm shadow-none"
                        onClick={() => openAudioAssocPanel(props)}
                        style={addStyle}
                        title={`Associated Audio Source to Scripts in the Batch "${props.project_name}"`}>
                        <i className="bi bi-soundwave"></i>
                    </button> :
                    <i style={addStyle} className="bi bi-soundwave"></i>

            )
        }
    }

    const openAudioAssocPanel = (props) => {
        const numberOfScriptID = props.subtasks.reduce((acc, item) => {

            if (!acc.includes(item.scriptIdGroup)) {
                acc.push(item.scriptIdGroup);
            }
            return acc;
        }, []).length;


        if (numberOfScriptID === 1) {

            let languageCodes = props.taskData.subtasks.map((item) => item.language_code);
            let joinedLanguageCodes = languageCodes.join(', ');

            const obj = {
                type: 'Source',
                selection: props.idTarget,
                info: {
                    script_name: props.taskData.subtasks[0].project_name,
                    languages: joinedLanguageCodes,
                    uploadReference: props.taskData.downloadReference
                }
            }
            sourcePanelRef.current.openSourceModal(obj)
        } else {
            targetPanel1Ref.current.receiveTargeID({ key: props.idElement, type: 'Source' })
        }


        //console.log(batchId)
    }

    /***************************************************************************************** */
    function storeStatus() {
        window.localStorage.setItem('currentData', JSON.stringify(expendedStatus));
    }

    function collapsed(args) {
        function arrayRemove(arr, value) {
            return arr.filter(function (geeks) {
                return geeks !== value;
            });

        }
        expendedStatus = arrayRemove(expendedStatus, args.data.taskID);
        storeStatus()
    }

    function expanded(args) {
        expendedStatus.push(args.data.taskID)
        storeStatus()
    }

    /***************************************************************************************** */

    const dataBound = () => {
        if (gridObj !== null) {
            let cloned = gridObj.addOnPersist;
            gridObj.addOnPersist = function (key) {
                key = key.filter((item) => item === "selectedRowIndex" || item === "scrollPosition" || item === "columns");
                return cloned.call(this, key);
            }
        }
    }

    /************************************** */

    function closeModalTarget() {

    }

    function openModalTarget(props) {

        const numberOfScriptID = props.subtasks.reduce((acc, item) => {

            if (!acc.includes(item.scriptIdGroup)) {
                acc.push(item.scriptIdGroup);
            }
            return acc;
        }, []).length;



        if (numberOfScriptID === 1) {

            let languageCodes = props.taskData.subtasks.map((item) => item.language_code);
            let joinedLanguageCodes = languageCodes.join(', ');

            const obj = { type: 'Source', selection: props.idTarget, info: { script_name: props.taskData.subtasks[0].project_name, languages: joinedLanguageCodes } }

            targetPanel2Ref.current.receiveTargeID(obj)
        } else {
            /* send the ID to the child component target panel 1 (01_Projects_AudioTargetSetting1.js */
            targetPanel1Ref.current.receiveTargeID({ key: props.idElement, type: 'Target' })
        }
    }

    function iconTargetAssoc(props) {
        if (props.lineContent === 'script') {
            let addStyle = { marginRight: '5px', fontSize: '12px', padding: '0px', color: '#F00', cursor: 'default' }
            let title = `No FileType(s) of "${props.project_name}" are set`
            if (props.filetypes_created === '1') {
                addStyle.color = '#4154F1'
                title = `FileType(s) of "${props.project_name}" are set`
            }

            return (<button className="btn btn-sm shadow-none"
                style={addStyle}
                title={title}>
                <SettingsInputCompositeIcon style={{ fontSize: '10px' }} />

            </button>)
        }
        if (props.lineContent === 'batch' && props.sharedActive === 1) {

            let addStyle = { marginRight: '5px', fontSize: '16px', padding: '0px', color: '#4154F1' }

            return (
                <>
                    <button className="btn btn-sm shadow-none"
                        onClick={() => openModalTarget(props)}
                        style={addStyle}
                        title={`Set FileTypes to Scripts in Batch "${props.project_name}"`}>
                        <SettingsInputCompositeIcon style={{ fontSize: '14px' }} />
                    </button>
                </>
            )
        }
    }

    function uploadLinks(props) {

        const positionLink = { position: 'relative', padding: '0px', margin: '2px', top: '3px', border: '0px' }

        if (props.lineContent === 'script' && props.uploadReference) {
            const { batch_id, project_id, script_id } = props.uploadReference;


            let disabled = true;
            let disabledTitle = 'No Filetypes are set'
            if (props.filetypes_created === '1' && props.status !== '1') {
                disabled = false;

            }

            const goto = (props) => {
                navigate(props);
            }

            return <>
                <Protected returnNull={true} permissions={['TargetUploadFiles']} >
                    <button title={disabled ? disabledTitle : "Open Upload page for the Target"} className="btn btn-sm  btn-outline-primary shadow-none" disabled={disabled} style={positionLink}
                        onClick={() => goto(`/uploads/target-${project_id}-${batch_id}-${script_id}`)}>
                        <i className="bi bi-cloud-upload-fill"></i>
                    </button>
                </Protected>
                <Protected returnNull={true} permissions={['TargetDownloadFiles']} >
                    <button title={disabled ? disabledTitle : "Open Download page for the Target"} className="btn btn-sm btn-outline-primary shadow-none" disabled={disabled} style={positionLink}
                        onClick={() => goto(`/downloads/target-${project_id}-${batch_id}`)}><i className="bi bi-cloud-download-fill"></i>
                    </button>
                </Protected>
            </>
        }

        if (props.lineContent === 'project') {
            return (
                <Protected returnNull={true} permissions={['SourceUploadFiles']} >
                    <Link title="Open Upload page for the Source" to={`/uploads/source-${props.idElement}`} style={positionLink}><i className="bi bi-cloud-upload-fill" style={{ color: 'green' }}></i></Link>
                </Protected>
            )
        }

        if (props.lineContent === 'batch') {
            const { project_id, batch_id } = props.downloadReference;
            return (
                <Protected returnNull={true} permissions={['SourceDownloadFiles']} >
                    <Link title="Open Download page for the Source" to={`/downloads/source-${project_id}-${batch_id}`} style={positionLink}><i className="bi bi-cloud-download-fill" style={{ color: '#0d6efd' }}></i></Link>
                </Protected>
            )
        }
    }


    const closeModalSetting = () => {
        targetPanel2Ref.current.removeUI()
        close('reload')
    }

    const preceedingOpenBatch = (props) => {

        if (props.type === 'Source') {
            sourcePanelRef.current.openSourceModal(props)
        } else {
            targetPanel2Ref.current.receiveTargeID(props)
        }
    }


    /* close all the line opened */
    const collapseAll = () => {
        gridObj.collapseAtLevel(1)
        gridObj.collapseAtLevel(0)
        try {
            window.localStorage.setItem('currentData', JSON.stringify([]));
            //close('reload')
        } catch (err) { console.log(err) }
    }


    /* search */
    const searchHandler = (props) => {

        if (props === '') {
            gridObj.search(props)
            setTimeout(() => {
                //gridObj.collapseAll()
            }, 100);
        } else {
            gridObj.search(props)
            //gridObj.expandAll()
        }
    }

    function columnProjectsBatchesScriptsTemplate(props) {
        return <>
            Project / Batch / Script Name
            <button type="button" className="btn btn-outline-primary btn-sm"
                onClick={collapseAll}
                style={{ height: '19px', padding: '0px 5px', lineHeight: '1', marginTop: '5px', float: 'right', fontSize: '11px' }}
                title="Collapse all the rows"
            >Collapse</button>
        </>
    }

    const showColumnChooser = (e) => {
        const button = e.currentTarget;
        gridObj.columnChooserModule.openColumnChooser(button.offsetLeft - gridObj.element.offsetLeft, 1);
    }

    const hideColumns = (field) => {
        const col = gridObj?.getColumnByField(field);
        if (col) gridObj.hideColumns(field, 'field');

    }

    const hideColumnTemplate = (props) => {
        return (
            <div style={{ display: 'flex', flexWrap: 'nowrap', justifyContent: 'space-between', alignItems: 'center', maxHeight: '29px' }}>
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {props.headerText}
                </span>
                <button id='grid-header-button'
                    type="button"
                    title="Hide column"
                    className='grid-header-button bi bi-eye-slash'
                    onClick={() => hideColumns(props.field)}
                />
            </div>
        )
    }

    function centerAlignHeaderTemplate(props) {
        return <span title={props.headerText} style={{ padding: '0 6px' }}>{props.headerText}</span>
    }

    /* info Edit Line */

    const infoEditLine = (props) => {
        projectInfoEditRef.current.openInfoModal(props)
    }

    function changeView(props) {

        levelPBSRef.current = props

        const fetchUrl = async () => {
            const result = await axios.get(API_ADR(`projectList=${levelPBSRef.current.join(',')}`));
            gridObj.setProperties({ dataSource: tempFunction(result.data.dataTable2, result.data.permissions, result.data.userId, null, dummyRefs) })
            //setValuesTableGrid(previous => )
            setTimeout(function () {
                setIsLoading(false)
            }, 300)

        };
        fetchUrl();
    }

    const pageSettings = { pageSize: 20, pageSizeMode: 'Root' };
    const infiniteOptions = { initialBlocks: 3 };

    const searchSettings = {
        hierarchyMode: 'Both',
        fields: ['project_name', 'master_project_name', 'franchise_name', 'language_code', 'client_name', 'pm_name', 'share', 'joinGroups', 'searchDate', 'projectContact'],
        ignoreCase: true,
        operator: 'contains',
        ...(currentFilterValue.current !== '' ? { key: currentFilterValue.current } : {})
    };

    const showHideDummy = (e, batchId) => {
        const data = dummyRefs.current?.[batchId];
        if(!data) return; 
        data.active = !data.active;
        Object.values(data.rows).forEach(r => {
            if(data.active) { r.classList.remove(`hidden`) } else { r.classList.add(`hidden`) }; 
        })
        e.currentTarget.classList.remove('bi-eye');
        e.currentTarget.classList.remove('bi-eye-slash');
        e.currentTarget.classList.add(data.active ? 'bi-eye' : 'bi-eye-slash');
        e.currentTarget.title = `${data.active ? 'Hide' : 'Show'} deactivated dummy scripts` 
    } 

    const rowDataBound = (args) => {
        args.row.classList.add(`projects_level_${args.data.lineContent}`);
        if(args.data?.dummyInactive) {
            args.row.classList.add('deactivated');
            const bId = args.data.uploadReference.batch_id;
            const sId = args.data.idElement ;
            if(!dummyRefs.current?.[bId]) dummyRefs.current[bId] = {active: false, rows: {}};
            dummyRefs.current[bId].rows[sId] = args.row;
            if(!dummyRefs.current[bId].active) args.row.classList.add('hidden');
        }
    }

    //const testFn = async(loops = 0, endpoint = null, rateLimit = 0) => {
    //    if(!endpoint) return;
    //    let start = new Date();
    //    console.log('Starting');
    //    dBConn.post(endpoint, {}).then(r => {
    //        if(r?.success) {
    //            if(!r.continue || loops >= 100) {
    //                console.log('Finished.', 'Errors:' + (r?.errors ?? 'No'));
    //            } else {
    //                const timeFromLast = (new Date() - start);
    //                if(timeFromLast >= rateLimit) {
    //                    testFn(loops + 1, endpoint, rateLimit);
    //                } else {
    //                    setTimeout(() => testFn(loops + 1, endpoint, rateLimit), rateLimit - timeFromLast);
    //                }
    //                console.log(loops, 'Errors:' + (r?.errors ?? 'No'));
    //            }
    //        } else {
    //            console.log(r?.errors ?? 'Error');
    //        }   
    //    });
    //}

    return (
        <>
            {colorEditor && (
                <>
                    {/* Click-away backdrop: closes without saving */}
                    <div
                        onClick={() => setColorEditor(null)}
                        style={{ position: 'fixed', inset: 0, zIndex: 9998 }}
                    />
                    <div
                        style={{ position: 'fixed', top: colorEditor.top, left: colorEditor.left, zIndex: 9999 }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <ColorPickerComponent
                            inline={true}
                            showButtons={true}
                            mode="Picker"
                            modeSwitcher={true}
                            value={colorEditor.color}
                            change={(e) => {
                                saveProjectColor(colorEditor.projectId, e.value.toUpperCase().slice(0, -2));
                                setColorEditor(null);
                            }}
                        />
                    </div>
                </>
            )}

            <main id="main" className="main">

                <ProjectsShareForm ref={sharePanelRef} typeofOp={operation} close={close} />
                <ProjectsAudioAssociation ref={sourcePanelRef} close={close} />
                <ProjectsAudioTargetSetting1 ref={targetPanel1Ref} closeModalTarget={closeModalTarget} preceedingOpenBatch={preceedingOpenBatch} />
                <ManageTargetAssets ref={targetPanel2Ref} onApplySettings={closeModalSetting} />
                <ProjectInfoEdit ref={projectInfoEditRef} close={close} />
                <ProjectHeaderProjects name="Projects" />{/* header*/}
                <div className="card">
                    <div className="card-body mt-3 projectsmodule">
                        <div className="d-flex align-items-center w-100">
                            <ClonedButtons ref={newButtonBar} onClickNew={linkTo_new} />
                            {/*
                                <Fragment>
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm"
                                        style={{ margin: '0 8px 0 auto', borderRadius: '4px', padding: '4px', height: '30px'}}
                                        onClick={() => testFn(0, 'encriptNames', 0)}
                                    >
                                        Encrypt_Names
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm"
                                        style={{ margin: '0 8px 0 auto', borderRadius: '4px', padding: '4px', height: '30px'}}
                                        onClick={() => testFn(0, 'createClerkUsers', 1000)}
                                    >
                                        Create_Clerk_Users
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary btn-sm"
                                        style={{ margin: '0 8px 0 auto', borderRadius: '4px', padding: '4px', height: '30px'}}
                                        onClick={() => testFn(0, 'updateClerkUsers', 1000)}
                                    >
                                        Update_Clerk_Users
                                    </button>
                                </Fragment>
                            */}
                            <button
                                type="button"
                                title="Show/Hide columns"
                                className="bi bi-eye btn btn-outline-primary btn-sm"
                                style={{ margin: '0 8px 0 auto', borderRadius: '4px', fontSize: '18px', aspectRatio: '1', padding: '0', height: '30px' }}
                                onClick={showColumnChooser}
                            />
                            <div className="d-flex align-items-center">
                                <FilterStatus data={levelPBSRef.current} updateConfig={changeView} />
                                <InputSearch onSearch={searchHandler} currentValue={currentFilterValue.current} />
                            </div>
                        </div>
                        <div className="projectlist">
                            <TreeGridComponent
                                key={refresh}
                                id="listProjectTable"
                                ref={grid => gridObj = grid}
                                dataSource={valuesTableGrid}
                                treeColumnIndex={1}
                                childMapping='subtasks'
                                height="100%"
                                dataBound={dataBound}
                                rowDataBound={rowDataBound}
                                autoCheckHierarchy={true}
                                //enableCollapseAll={true}
                                headerCellInfo={headerCellInfo}
                                checkboxChange={checkboxChange}
                                collapsed={collapsed}
                                expanded={expanded}
                                enablePersistence={true}
                                expandStateMapping='IsExpanded'
                                selectionSettings={{ enableToggle: false }}
                                allowSelection={true}
                                allowResizing={true}
                                allowFiltering={true}
                                filterSettings={{ type: 'Excel', hierarchyMode: 'Both' }}
                                gridLines='Both'
                                showColumnChooser={true}
                                searchSettings={searchSettings}
                                /*enableInfiniteScrolling={true}*/
                                enableVirtualization={false}
                                //infiniteScrollSettings={infiniteOptions}
                                pageSettings={pageSettings}
                                allowPaging={true}
                            //onRowExpanding={handleRowExpanding}                             
                            >
                                <ColumnsDirective>
                                    <ColumnDirective key='taskID' field='taskID' headerText='#' width='100' textAlign='Center' isPrimaryKey={true} visible={false} showInColumnChooser={false} />
                                    <ColumnDirective key='project_name' field='project_name' headerTemplate={columnProjectsBatchesScriptsTemplate} headerText='Project / Batch / script Name' template={iconsProjectName} width='280' minWidth='280' showCheckbox={true} allowFiltering={false} showInColumnChooser={false} />
                                    <ColumnDirective
                                        key='master_project_name'
                                        field='master_project_name'
                                        valueAccessor={(f, data) => data.lineContent === 'project' && data.master_project_name !== '* Unassigned *' ? data.master_project_name : null}
                                        headerTemplate={hideColumnTemplate}
                                        headerText='Master Project'
                                        width='120'
                                        minWidth='80'
                                        allowFiltering={true}
                                        visible={true} />
                                    <ColumnDirective
                                        key='franchise_name'
                                        field='franchise_name'
                                        valueAccessor={(f, data) => data.lineContent === 'project' ? data.franchise_name : null}
                                        headerTemplate={hideColumnTemplate}
                                        headerText='Franchise'
                                        width='120'
                                        minWidth='80'
                                        allowFiltering={true}
                                        visible={true} />
                                    {/* Visible column with flags (no filtering) */}
                                    <ColumnDirective key='language_code' field='language_code' template={flagsTemplate} headerText='Languages' width='210' customAttributes={{ class: 'removeWrap' }} showInColumnChooser={false} />
                                    {/* Hidden column for filtering languages by text */}
                                    <ColumnDirective key='language_text' field='language_text' headerText='Languages (Filter)' width='150' allowFiltering={true} visible={false} showInColumnChooser={false} />

                                    <ColumnDirective key='client_name' field='client_name' template={clientTemplate} headerText='Client Name' width='120' headerTemplate={hideColumnTemplate} />
                                    <ColumnDirective key='projectContact' field='projectContact' template={pmsAplsQacsTemplate} headerText='PM & Internal Team' width='100' headerTemplate={hideColumnTemplate} />
                                    <ColumnDirective key='share' field='share' headerText='Share' width='120' template={sharingSystem} textAlign='Left' allowFiltering={false} headerTemplate={hideColumnTemplate} />
                                    <ColumnDirective
                                        key='sourceAudio'
                                        field='sourceAudio' headerText='Source Audio' width='50'
                                        visible={ctx.userData.current?.permissions?.SourceUploadFiles ?? false}
                                        showInColumnChooser={false}
                                        headerTemplate={centerAlignHeaderTemplate}
                                        template={iconAudioAssociation} textAlign='Center' customAttributes={{ class: 'removemargins' }} allowFiltering={false}
                                    />
                                    {/*permissionLogic(userPermission, 'setAdaptationMarks') &&
                                <ColumnDirective field='' headerText='A.Marks' width='50' template={iconAdaptMarksAssociation} textAlign='Center' maxWidth={50} minWidth={50} customAttributes={ { class: 'removemargins' }}/>*/}
                                    <ColumnDirective
                                        key='targetSettings'
                                        field='targetSettings' headerText='Target Settings'
                                        visible={ctx.userData.current?.permissions?.TargetUploadFiles ?? false}
                                        showInColumnChooser={false}
                                        headerTemplate={centerAlignHeaderTemplate}
                                        width='50'
                                        template={iconTargetAssoc} textAlign='Center' customAttributes={{ class: 'removemargins' }} allowFiltering={false}
                                    />
                                    <ColumnDirective
                                        key='uploadDownload'
                                        field='uploadDownload'
                                        headerText='Upload&Download'
                                        headerTemplate={centerAlignHeaderTemplate}
                                        width='50'
                                        visible={
                                            ['TargetUploadFiles', 'TargetDownloadFiles', 'SourceUploadFiles', 'SourceDownloadFiles'].some(item => ctx.userData.current?.permissions?.[item])
                                        }
                                        showInColumnChooser={false}
                                        template={uploadLinks} textAlign='Center' customAttributes={{ class: 'removemargins' }} allowFiltering={false}
                                    />
                                    <ColumnDirective key='startDate' field='startDate' headerText='Start' headerTemplate={centerAlignHeaderTemplate} template={startDateTemplate} width='100' textAlign='Center' allowFiltering={false} showInColumnChooser={false}/*format='d/M/y' type='date'*/ />
                                    <ColumnDirective key='endDate' field='endDate' headerText='End' headerTemplate={centerAlignHeaderTemplate} template={endDateTemplate} width='100' textAlign='Center' allowFiltering={false} showInColumnChooser={false} /*format='d/M/y' type='date'*/ />
                                    <ColumnDirective key='status' field='status' headerText='Status' headerTemplate={hideColumnTemplate} template={templateStatus} width='100' />
                                    <ColumnDirective key='joinGroups' field='joinGroups' headerText='joinGroups' width='100' visible={false} showInColumnChooser={false} />
                                    <ColumnDirective key='searchDate' field='searchDate' headerText='joinGroups' width='100' visible={false} showInColumnChooser={false} />
                                </ColumnsDirective>
                                <Inject services={[Resize, Filter, VirtualScroll, Page, ColumnChooser, /*InfiniteScroll*/]} />
                            </TreeGridComponent>
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}



function tempFunction(table, permissionsTable, userId, ctx, dummyRefs) {

    function openNodeYorN(id) {
        if (expendedStatus.includes(id)) {
            return true
        } else {
            return false
        }
    }

    if (localStorage.getItem('currentData') !== null) {
        expendedStatus = JSON.parse(localStorage.getItem('currentData'))
    }

    let outputArray = [];
    let previousProjectName = 0;
    let previousBatcvhName = 0;
    let counterProject = -1;
    let counterBatch = -1;
    let projectShared = -1;
    let batchShared = -1;

    const superuser = permissionsTable[0].admin === '1';
    const internalResource = permissionsTable[0].internal_resource === '1';

    const resources = table.resources;
    const prjData = table.projectData;
    const batchData = table.batchData;
    const scriptData = table.scriptData;

    const prjSharing = {};
    table.projectSharing.forEach(i => {
        if(!prjSharing?.[i.project_id]) prjSharing[i.project_id] = [];
        const name = `${i.is_group === 0 ? resources[i.resource_id] : '\0'}${i.group}`;
        prjSharing[i.project_id].push(name);
    });

    const batchSharing = {};
    table.batchSharing.forEach(i => {
        if(!batchSharing?.[i.batch_id]) batchSharing[i.batch_id] = [];
        const name = `${i.is_group === 0 ? resources[i.resource_id] : '\0'}${i.group}`;
        batchSharing[i.batch_id].push(name);
    });

    const scriptSharing = {};
    table.scriptSharing.forEach(i => {
        if(!scriptSharing?.[i.script_language_id]) scriptSharing[i.script_language_id] = [];
        const name = `${i.is_group === 0 ? resources[i.resource_id] : '\0'}${i.group}`;
        scriptSharing[i.script_language_id].push(name);
    });

    const data = table.data;

    data.forEach(function (el, idx) {

        if (el.project_id !== previousProjectName) {

            el.project_name = prjData[el.project_id].name;
            el.master_project_name = prjData[el.project_id].master;
            el.franchise_name = prjData[el.project_id].franchise;
            el.client_name = prjData[el.project_id].client;
            el.project_color = prjData[el.project_id].color;
            el.project_groups = (prjSharing[el.project_id] ?? []).sort((a, b) => a.localeCompare(b)).join(', ').replace(/\0/g, '');

            projectShared = superuser || el.creation_resource_id === userId || el.pm_id === userId || permissionsTable.some((i) => { return i['project_id'] === el.project_id; }) ? 1 : -1;
            counterBatch = -1;
            counterProject++;
            outputArray.push({
                taskID: `P${el.project_id}`,
                idElement: el.project_id,
                project_name: el.project_name,
                project_color: el.project_color,
                master_project_name: el.master_project_name,
                franchise_name: el.franchise_name,
                client_name: el.client_name,
                status: el.project_status,
                lineContent: 'project',
                joinGroups: el.project_groups,
                IsExpanded: openNodeYorN(`P${el.project_id}`),
                subtasks: [],
                sharedActive: projectShared,
                projectContact: ``
            })
        }
        if ((el.batch_id !== previousBatcvhName) && (el.batch_id !== null)) {

            el.batch_name = batchData[el.batch_id];
            el.master_project_name = prjData[el.project_id].master;
            el.pm_name = el.pm_id ? resources[el.pm_id] : 'Unassigned';
            el.apl_name = el.apl_id ? resources[el.apl_id] : null;
            el.qac_name = el.qac_id ? resources[el.qac_id] : null;
            el.batch_groups = (batchSharing[el.batch_id] ?? []).sort((a, b) => a.localeCompare(b)).join(', ').replace(/\0/g, '');

            batchShared = superuser || projectShared > -1 || el.pm_id === userId || permissionsTable.some((i) => { return i['batch_id'] === el.batch_id; }) ? 1 : -1;

            counterBatch++;
            outputArray[counterProject].subtasks.push({
                taskID: `B${el.batch_id}`,
                idElement: el.batch_id,
                downloadReference: {
                    project_id: el.project_id,
                    batch_id: el.batch_id
                },
                idTarget: el.script_id,
                project_name: el.batch_name,
                master_project_name: el.master_project_name,
                startDate: new Date(el.batch_start_date),
                endDate: new Date(el.batch_end_date),
                searchDate: `${dayjs(el.batch_start_date).format('D-MMM-YYYY')}|${dayjs(el.batch_end_date).format('D-MMM-YYYY')}`,
                pm_name: el.pm_name,
                apl_id: el.apl_id,
                apl_name: el.apl_name,
                qac_id: el.qac_id,
                qac_name: el.qac_name,
                projectContact: `${el.pm_name} | ${el.apl_name} | ${el.qac_name}`,
                status: el.batch_status,
                lineContent: 'batch',
                joinGroups: el.batch_groups,
                audiobase_set: el.audiobase_set,
                IsExpanded: openNodeYorN(`B${el.batch_id}`),
                subtasks: [],
                sharedActive: batchShared
            })
        }
        if (el.script_id !== null) {
            el.script_name = scriptData[el.script_id];
            el.master_project_name = prjData[el.project_id].master;
            el.pm_name = el.pm_id ? resources[el.pm_id] : 'Unassigned';
            el.script_lang_groups = (scriptSharing[el.script_lang_id] ?? []).sort((a, b) => a.localeCompare(b)).join(', ').replace(/\0/g, '');

            outputArray[counterProject].subtasks[counterBatch].subtasks.push({
                taskID: parseInt(el.script_lang_id),
                idElement: el.script_lang_id,
                uploadReference: {
                    project_id: el.project_id,
                    batch_id: el.batch_id,
                    script_id: el.script_id
                },
                //refBatch: el.batch_id,
                project_name: el.script_name,
                master_project_name: el.master_project_name,
                language_code: el.language_code,
                startDate: new Date(el.script_start_date),
                endDate: new Date(el.script_end_date),
                searchDate: `${dayjs(el.script_start_date).format('D-MMM-YYYY')}|${dayjs(el.script_end_date).format('D-MMM-YYYY')}`,
                pm_name: el.pm_name,
                status: el.script_status,
                joinGroups: el.script_lang_groups,
                adaptmarks_set: el.adaptmarks_set,
                scriptIdGroup: el.script_id,
                filetypes_created: el.filetypes_created,
                isDummy: el.script_placeholder === '1',
                dummyInactive: el.active === '2',
                audiobase_set: el.audiobase_set,
                IsExpanded: openNodeYorN(parseInt(el.script_lang_id)),
                lineContent: 'script',
                sharedActive: (superuser || projectShared > -1 || batchShared > -1 || el.pm_id === userId) ? internalResource ? 1 : 0 :
                    permissionsTable.some((i) => { return i['script_language_id'] === el.script_lang_id }) ? 0 : -1,
                projectContact: ``
            })

            if(el.active === '2') {
                const bId = el.batch_id;
                const sId = el.script_lang_id;
                if(!dummyRefs.current?.[bId]) dummyRefs.current[bId] = {active: false, rows: {}};
                dummyRefs.current[bId].rows[sId] = null;
            }

        }

        previousProjectName = el.project_id;
        previousBatcvhName = el.batch_id;

    })

    outputArray.sort((a, b) => a.project_name.localeCompare(b.project_name));
    outputArray.forEach(function (el) {

        let projectsLanguages = []
        el.subtasks.forEach(function (el2) {
            el2.subtasks.forEach(function (el3) {
                projectsLanguages.push(el3.language_code)
            })
        })

        /* remove duplicates and sort */
        projectsLanguages = [...new Set(projectsLanguages.sort())]
        el.language_code = projectsLanguages
    })
    return outputArray
}

const ClonedButtons = forwardRef((props, ref) => {

    const ctx = useContext(InfoContext);

    const [disableButtons, setDisableButtons] = useState({
        disabled: true,
        ids: {}
    });
    // eslint-disable-next-line  
    //const [userPermission, setUserPermission] = useState(takePermissionLocalStorage)

    useImperativeHandle(ref, () => ({
        statusBar(props) {
            setDisableButtons(previous => props)
        },
    }));

    const linkTo = (e, target) => {
        props.onClickNew({
            target: target,
            ids: disableButtons.ids.join('-'),
            event: e
        })
    }

    return (
        <div id="ProjectsMatrix" className="btn-group mr-2 btn-group-sm flex-wrap" role="group" aria-label="First group" /*style={{maxWidth: '800px'}}*/>
            <Protected returnNull={true} permissions={['view_Overview']} >
                <button className="btn btn-sm" onClick={(e) => linkTo(e, 'overview')} disabled={disableButtons.disabled}><i className="bi bi-graph-up" title="Open the Overview"></i> Overview</button>
            </Protected>
            <Protected returnNull={true} permissions={['view_Breakdown']} >
                <button className="btn btn-sm" onClick={(e) => linkTo(e, 'breakdown')} disabled={disableButtons.disabled}><i className="ri-list-unordered" title="Open Breakdown"></i> Breakdown</button>
            </Protected>
            <Protected returnNull={true} permissions={['view_ScriptBase']} >
                <button title="Open Script" className="btn btn-sm" onClick={(e) => linkTo(e, 'script')} disabled={disableButtons.disabled}><i className="bx bx-grid" title="Open Script"></i> Script Grid</button>
            </Protected>
            <Protected returnNull={true} permissions={['view_ExcelModule']} >
                <button className="btn btn-sm" onClick={(e) => linkTo(e, 'excel')} disabled={disableButtons.disabled}><i className="bx bx-spreadsheet" title="Open the Excel"></i> Script Excel</button>
            </Protected>
            <Protected returnNull={true} permissions={['view_GantChart']} >
                <button className="btn btn-sm" onClick={(e) => linkTo(e, 'gantt')} disabled={disableButtons.disabled}><i className="ri-map-pin-time-line" title="Open the Gantt Chart"></i> Gantt</button>
            </Protected>
            <Protected returnNull={true} permissions={['view_Trello']} >
                <button className="btn btn-sm" onClick={(e) => linkTo(e, 'production')} disabled={disableButtons.disabled}><i className="ri-task-line" title="Open the Production"></i> Production</button>
            </Protected>
            <Protected returnNull={true} permissions={['ShareSession']} >
                <button className="btn btn-sm" onClick={(e) => linkTo(e, 'sessions')} disabled={disableButtons.disabled} style={{ whiteSpace: 'nowrap' }}>
                    <i className="bi bi-collection" title="Open Recording Sessions"></i> Rec. Sessions
                </button>
            </Protected>
            <Protected returnNull={true} permissions={['actorsContracts']} >
                <button className="btn btn-sm" onClick={(e) => linkTo(e, 'actors')} disabled={disableButtons.disabled} style={{ whiteSpace: 'nowrap' }}>
                    <i className="bi bi-person-fill" title="Open Project Actors"></i> AOR & Credits
                </button>
            </Protected>
            <Protected returnNull={true} permissions={['view_Media']} >
                <button className="btn btn-sm" onClick={(e) => linkTo(e, 'inspector')} disabled={disableButtons.disabled}><i className="bi bi-soundwave" title="Open Media"></i> Inspector</button>
            </Protected>
            <Protected returnNull={true} permissions={['manageAssets']} >
                <button className="btn btn-sm" onClick={(e) => linkTo(e, 'explorer')} disabled={disableButtons.disabled}>
                    <i className="bi bi-folder" title="Open Explorer"></i> Explorer
                </button>
            </Protected>
            <Protected returnNull={true} permissions={['deliveryDashboard']} >
                <button className="btn btn-sm" onClick={(e) => linkTo(e, 'delivery')} disabled={disableButtons.disabled} style={{whiteSpace: 'nowrap', minWidth: 'fit-content'}}><i className="bi bi-clipboard-check" title="Open Tracking Matrix"></i> Tracking Matrix</button>
            </Protected>
        </div>
    )
})

const InputSearch = (props) => {

    const [inputValue, setInputValue] = useState(props.currentValue)

    useEffect(() => {
        let timeout;
        const handleSearch = () => {
            // Qui puoi inserire la tua logica di ricerca
            props.onSearch(inputValue)
        };

        timeout = setTimeout(() => {

            if (inputValue === '') {
                localStorage.removeItem('projectsSearch')
            } else {
                localStorage.setItem('projectsSearch', inputValue)
            }

            handleSearch();
        }, 500);

        return () => {
            clearTimeout(timeout);
        }
        // eslint-disable-next-line
    }, [inputValue]);


    const searchValue = (e) => {
        setInputValue(e.target.value)
    }

    return <input type="search" className="form-control form-control-sm" placeholder="Search"
        style={inputValue === '' ? { position: 'relative', marginTop: '-2px', width: '200px', height: '30px' }
            : { position: 'relative', marginTop: '-2px', width: '200px', height: '30px', background: '#ff00003b' }}
        onChange={searchValue} value={inputValue} spellCheck={false} />
}

const FilterStatus = (props) => {
    const switchClosed = useRef(null);

    // Use internal state to keep track of the checkbox value
    const [isChecked, setIsChecked] = useState(props.data.includes(1));

    const changeView = () => {
        const chosenView = [0, -1];

        setIsChecked(switchClosed.current.checked);

        if (switchClosed.current.checked) {
            chosenView.push(1);
            localStorage.setItem('projectsClosed', 'true')
        } else {
            localStorage.removeItem('projectsClosed')
        }

        setTimeout(function () {
            props.updateConfig(chosenView);
        }, 200);
    };

    const style = { height: '22px', width: '44px', marginRight: '4px', marginTop: '1px', cursor: 'pointer', }

    return (
        <><label className="form-check-label" htmlFor="flexSwitchCheckChecked" style={{ fontSize: '14px', cursor: 'pointer', width: '85px' }}>Show Closed</label>
            <div className="form-check form-switch" title="Include closed Projects/Batches/scripts" style={{ paddingRight: '5px', cursor: 'pointer' }}>
                <input
                    ref={switchClosed}
                    style={style}
                    className="form-check-input"
                    type="checkbox"
                    id="flexSwitchCheckChecked"
                    onChange={changeView}
                    checked={isChecked}
                />
            </div></>
    );
}